export default __webpack_public_path__ + "static/media/19-face-with-rolling-eyes_1f644.6e353f48.png";